import { environment } from './../../../../environments/environment';
import { Pillar } from './../../../models/pillar.model';
import { Response } from './../../../models/response.model';
import { Subscription } from 'rxjs';
import { BaseService } from './../../../services/base/base.service';
import { EPillar } from './../../../enums/pillar.enum';
import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-pillar-list',
  templateUrl: './pillar-list.component.html',
  styleUrls: ['./pillar-list.component.scss']
})
export class PillarListComponent implements OnInit {
  @Input() currentIdPillar: number = null;
  storageUrl = environment.BASE_STORAGE_URL;

  pillarList: Pillar[] = [];

  pillarSubscription: Subscription;

  get EPillar() {
    return EPillar;
  }

  constructor(
    private baseService: BaseService
  ) { }

  ngOnInit(): void {
    this.getData();
  }

  getData(): void {
    this.pillarSubscription = this.baseService.getAllNoHeader('pilares').subscribe((res: Response<Pillar[]>) => {
      if (res.retorno) {
        this.pillarList = res.data;
      }
    })
  }
}
